import { h } from "preact";

import { taskState } from "../helpers";
import StateIcon from "./StateIcon.jsx";

export default function TaskProgress({ task, small }) {
  return <StateIcon state={taskState(task)} small={small} />;
}
